import React from 'react'
import './layout.css'

const RoundContainer = ({ children }) => {
  const padding = '8px'
  return (
    <div
      style={{
        backgroundColor: 'var(--light-blue)',
        maxWidth: '750px',
        textAlign: 'center',
        marginLeft: 'Auto',
        marginBottom: '16px',
        marginRight: 'Auto',
        paddingTop: padding,
        paddingBottom: padding,
        paddingLeft: '16px',
        paddingRight: '16px',
        borderRadius: '8px',
      }}
    >
      {children}
    </div>
  )
}

export default RoundContainer
